import logger from "./logger";

const asArray = (v) => (Array.isArray(v) ? v : []);

const normalizeConnections = (conns) =>
  asArray(conns).map((c) => (Array.isArray(c) ? c.filter(Boolean) : []));

function validateNIP(nip, required = true) {
  logger.log(nip);
  if (!required && !nip) return true;

  nip = nip.replace(/[\s-]/g, "");

  if (nip.length !== 10 || !/^\d+$/.test(nip)) {
    return false;
  }

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7]; // Wagi dla poszczególnych cyfr NIP
  const controlSum = nip
    .substring(0, 9)
    .split("")
    .reduce((sum, digit, index) => sum + parseInt(digit) * weights[index], 0);

  const controlNumber = controlSum % 11;
  const controlDigit = parseInt(nip[9]);

  return controlNumber === controlDigit;
}

function validateProductName(productName, required = true) {
  if (!required && !productName) return true;
  if (!productName || productName.length > 350) return false;
  return validateLettersDigitsSpecChars(productName, 350, required);
  // const regex = /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9 !"#$%&'()*+,-./:;<=>?@[\]^_–`{|}~]+$/;
  // return regex.test(productName);
}

function validateLettersDigitsSpecChars(
  value,
  maxLength,
  required = true,
  maxLines = 0
) {
  if (!required && !value) return true;
  if (!value || value.replace(/\n/g, "").length > maxLength) return false;
  const lines = value.split("\n");
  if (maxLines > 0 && lines.length > maxLines) return false;
  const regex =
    /^[\p{L}\p{N}\s!×„”"#$%&'’‘()*+,-./:;<=>?@[\]^_–`{|}~]+$/u;
  return regex.test(value);
}

function validateLettersDigits(
  value,
  maxLength,
  required = true,
  maxLines = 0,
  allowSpecial = false
) {
  if (!required && !value) return true;
  if (!value || value.replace(/\n/g, "").length > maxLength) return false;
  const lines = value.split("\n");
  if (maxLines > 0 && lines.length > maxLines) return false;

  const regex = allowSpecial
    ? /^[\p{L}\p{N}\s.,:\/\\\-@"„”"'()&]*$/u
    : /^[\p{L}\p{N}\s.,:\/\\-]+$/u;

  return regex.test(value);
}

function validateLetters(value, maxLength, required = true) {
  if (!required && !value) return true;
  if (!value || value.length > maxLength) return false;
  const regex = /^[\p{L} -]+$/u;
  return regex.test(value);
}

function validateDigits(value, maxLength, required = true) {
  if (!required && !value) return true;
  if (!value || value.length > maxLength) return false;
  const regex = /^[0-9 ]+$/;
  return regex.test(value);
}

function validateDecimalNumber(value, maxLength, required = true) {
  if (!required && !value) return true;
  if (!value || value.length > maxLength) return false;
  const regex = /^[0-9 ]+(\.[0-9]{1,2})?$/;
  return regex.test(value);
}

function validateBusinessName(businessName, required = true) {
  if (!required && !businessName) return true;
  if (!businessName || businessName.length > 160) return false;
  const regex =
    /^[\p{L}\p{N}\s!×„”"#$%&'()*+,-./:;<=>?@[\]^_–`{|}~]+$/u;
  return regex.test(businessName);
}

function validateStreet(street, required = true) {
  if (!required && !street) return true;
  if (!street || street.length > 66) return false;
  const regex = /^[\p{L}\p{N}\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/u;
  return regex.test(street);
}

function validateBuilding(building, required = true) {
  if (!required && !building) return true;
  if (!building || building.length > 9) return false;
  const regex = /^[\p{L}\p{N}\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/u;
  return regex.test(building);
}

function validateAppartment(appartment, required = false) {
  if (!required && !appartment) return true;
  if (!appartment || appartment.length > 20) return false;
  const regex = /^[\p{L}\p{N}\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/u;
  return regex.test(appartment);
}

function validateCity(city, required = true) {
  if (!required && !city) return true;
  if (!city || city.length > 30) return false;
  const regex = /^[\p{L}\p{N}\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/u;
  return regex.test(city);
}

function validateCountryCode(countryCode, required = true) {
  if (!required && !countryCode) return true;
  if (!countryCode || countryCode.length > 2) return false;
  const regex = /^[a-zA-Z]/;
  return regex.test(countryCode);
}

function validatePostCode(postCode, required = true, international = false) {
  if (!required && !postCode) return true;

  if (!postCode) return false;

  // międzynarodowy kod pocztowy
  if (international) {
    if (postCode.length > 11) return false;
    return true;
  }

  // walidacja zgodnie z
  if (!/^\d{2}-\d{3}$/.test(postCode)) return false;
  return true;
}

function validateEmail(email, required = true) {
  if (!required && !email) return true;
  if (!email || email.length > 254) return false;
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

// Nowa walidacja kodu taryfy celnej
function validateTariffCode(value, required = true) {
  if (!required && !value) return true;
  // Akceptowane tylko 4, 6, 8 lub 10 cyfr
  return /^\d{4}$|^\d{6}$|^\d{8}$|^\d{10}$/.test(value);
}

function validateProduct(product) {
  let errors = [];

  if (!validateProductName(product.productName))
    errors.push(`Nazwa produktu ${product.productName} jest nieprawidłowa.`);
  if (!validateLettersDigits(product.quantity, 10))
    errors.push(`Ilość produktu ${product.productName} jest nieprawidłowa.`);
  if (!validateLettersDigits(product.unit, 30))
    errors.push(
      `Jednostka miary produktu ${product.productName} jest nieprawidłowa.`
    );
  if (
    !validateLettersDigits(
      product.quantity + product.unit + product.quantityDesc,
      38,
      true
    )
  )
    errors.push(
      `Opis ilości (ilość, jednostka, opcjonalne opisowe określenie ilości) produktu ${product.productName} jest nieprawidłowy.`
    );

  if (!validateTariffCode(product.tariffCode))
    errors.push(
      `Kod taryfy celnej produktu ${product.productName} jest nieprawidłowy. Kod taryfy celnej musi zawierać 4, 6, 8 lub 10 znaków.`
    );
  if (!validateCountryCode(product.originCountry))
    errors.push(
      `Kod kraju pochodzenia produktu ${product.productName} jest nieprawidłowy.`
    );
  if (!validateCountryCode(product.producerCountry))
    errors.push(
      `Kod kraju produkcji produktu ${product.productName} jest nieprawidłowy.`
    );
  if (
    product.producer === "" ||
    (product.producer !== "true" && product.exporter !== "true")
  )
    errors.push(
      `Wskazanie eksportera lub producenta produktu ${product.productName} jest wymagane.`
    );
  if (product.producer === "true") {
    if (!validateBusinessName(product.producerName))
      errors.push(
        `Nazwa producenta produktu ${product.productName} jest nieprawidłowa.`
      );
    if (!validateStreet(product.producerStreet))
      errors.push(
        `Adres producenta produktu ${product.productName} jest nieprawidłowy.`
      );
    if (!validateBuilding(product.producerBuilding))
      errors.push(
        `Numer budynku producenta produktu ${product.productName} jest nieprawidłowy.`
      );
    if (!validateAppartment(product.producerAppartment))
      errors.push(
        `Numer lokalu producenta produktu ${product.productName} jest nieprawidłowy.`
      );
    if (
      !validatePostCode(
        product.producerPostCode,
        true,
        product.producerCountry !== "PL"
      )
    )
      errors.push(
        `Kod pocztowy producenta produktu ${product.productName} jest nieprawidłowy.`
      );
    if (!validateCity(product.producerCity))
      errors.push(
        `Miasto producenta produktu ${product.productName} jest nieprawidłowe.`
      );
  }
  if (product.producer === "false") {
    if (product.boughtInEU === "")
      errors.push(
        `Wskazanie czy produkt ${product.productName} został zakupiony w UE jest wymagane.`
      );
    if (product.boughtInEU === "false") {
      if (product.importClearanceFile.id === "")
        errors.push(
          `Dokument potwierdzający odprawę importową produktu ${product.productName} jest wymagany.`
        );
    }
  }

  return errors;
}

function validateSummary(summary) {
  let errors = [];

  if (!validateLettersDigits(summary.totalQuantity, 33, false))
    errors.push(
      "Łączna ilość produktów / towarów w podsumowaniu jest nieprawidłowa."
    );
  if (!validateLettersDigits(summary.totalNetWeight, 22, false))
    errors.push(
      "Łączna waga netto produktów / towarów w podsumowaniu jest nieprawidłowa."
    );
  if (!validateLettersDigits(summary.totalGrossWeight, 20, false))
    errors.push(
      "Łączna waga brutto produktów / towarów w podsumowaniu jest nieprawidłowa."
    );
  if (
    [true, "true"].includes(summary.editCountriesOfOrigin) &&
    !summary.countriesOfOrigin?.trim()
  )
    errors.push(
      "Uzupełnij listę krajów pochodzenia (pole nr 3 na świadectwie)."
    );
  else if (!validateLettersDigitsSpecChars(summary.countriesOfOrigin, 160, false, 4))
    errors.push(
      "Kraje pochodzenia produktów / towarów w podsumowaniu są nieprawidłowe."
    );
  if (!validateLettersDigitsSpecChars(summary.transportDetails, 280, false))
    errors.push(
      "Szczegóły dotyczące transportu w podsumowaniu są nieprawidłowe."
    );
  if (!validateLettersDigitsSpecChars(summary.productsRemarks, 360, false))
    errors.push(
      "Uwagi dotyczące produktów / towarów w podsumowaniu są nieprawidłowe."
    );

  return errors;
}

function validateStep2(data) {
  let errors = [];
  const products = asArray(data?.Products);

  if (products.length === 0) {
    errors.push("Dodaj co najmniej jeden produkt / towar.");
  }

  products.forEach((product) => {
    errors.push(...validateProduct(product));
  });

  errors.push(...validateSummary(data.Summary));

  const normalizeProductName = (value) =>
    (value ?? "").toString().trim().replace(/\s+/g, " ").toLowerCase();

  const duplicates = new Map();
  products.forEach((product) => {
    const normalized = normalizeProductName(product.productName);
    if (!normalized) return;
    const entry = duplicates.get(normalized) || {
      count: 0,
      displayName: (product.productName ?? "").toString().trim(),
    };
    entry.count += 1;
    if (!entry.displayName && product.productName)
      entry.displayName = product.productName.toString().trim();
    duplicates.set(normalized, entry);
  });

  duplicates.forEach((entry) => {
    if (entry.count > 1) {
      errors.push(
        `Wprowadzono ${entry.count} pozycje o tej samej nazwie produktu: "${entry.displayName}". Zsumuj pozycje lub zmień nazwy, aby były unikalne.`
      );
    }
  });

  return errors;
}

function validateStep1(data) {
  let errors = [];

  if (data.exportFromPoland !== "true")
    errors.push("Wskazanie czy eksportujesz z Polski jest wymagane.");
  if (!validateLettersDigitsSpecChars(data.displayName, 160, true))
    errors.push("Nazwa robocza wniosku jest nieprawidłowa.");
  if (data.applicantId === "")
    errors.push("Dane eksportera/wnioskodawcy są wymagane.");
  else {
    if (!validateBusinessName(data.applicantName, true))
      errors.push("Nazwa eksportera/wnioskodawcy jest nieprawidłowa.");
    if (!validateNIP(data.applicantNIP, true))
      errors.push("NIP eksportera/wnioskodawcy jest nieprawidłowy.");
    if (!validateStreet(data.applicantStreet, true))
      errors.push("Adres eksportera/wnioskodawcy jest nieprawidłowy.");
    if (!validateBuilding(data.applicantBuilding, true))
      errors.push("Numer domu eksportera/wnioskodawcy jest nieprawidłowy.");
    if (!validateAppartment(data.applicantAppartment, false))
      errors.push("Numer lokalu eksportera/wnioskodawcy jest nieprawidłowy.");
    if (!validatePostCode(data.applicantPostCode, true))
      errors.push("Kod pocztowy eksportera/wnioskodawcy jest nieprawidłowy.");
    if (!validateCity(data.applicantCity, true))
      errors.push("Miasto eksportera/wnioskodawcy jest nieprawidłowe.");
  }
  if ([true, "true"].includes(data.editExporterCertificateData))
    if (
      !validateLettersDigits(data.exporterCertificateData, 200, true, 5, true)
    )
      errors.push("Dane eksportera są nieprawidłowe.");
  if ([true, "true"].includes(data.signedByAgent)) {
    if (data.agentId === "")
      errors.push("Dane firmy składającej wniosek są wymagane.");
    else {
      if (!validateNIP(data.agentNIP, true))
        errors.push("NIP firmy składającej wniosek jest nieprawidłowy.");
      if (!validateBusinessName(data.agentName, true))
        errors.push("Nazwa firmy składającej wniosek jest nieprawidłowa.");
      if (!validateStreet(data.agentStreet, true))
        errors.push("Adres firmy składającej wniosek jest nieprawidłowy.");
      if (!validateBuilding(data.agentBuilding, true))
        errors.push("Numer domu firmy składającej wniosek jest nieprawidłowy.");
      if (!validateAppartment(data.agentAppartment, false))
        errors.push(
          "Numer lokalu firmy składającej wniosek jest nieprawidłowy."
        );
      if (!validatePostCode(data.agentPostCode, true))
        errors.push(
          "Kod pocztowy firmy składającej wniosek jest nieprawidłowy."
        );
      if (!validateCity(data.agentCity, true))
        errors.push("Miasto firmy składającej wniosek jest nieprawidłowe.");
    }

    if (data.proxyFiles.length > 0) {
      if (data.proxyFiles[0].id === "")
        errors.push(
          "Dokument reprezentacji Eksportera przez firmę Wnioskodawcy jest wymagany."
        );
    } else
      errors.push(
        "Dokument reprezentacji Eksportera przez firmę Wnioskodawcy jest wymagany."
      );
  }
  if (
    [false, "false"].includes(data.signedIndependently) &&
    [false, "false"].includes(data.signedByProxy) &&
    [false, "false"].includes(data.signedByAgent)
  )
    errors.push("Wskazanie reprezentacji do podpisu wniosku jest wymagane.");
  if (
    [false, "false"].includes(data.exporterIsProducer) &&
    [false, "false"].includes(data.exporterIsNotProducer)
  )
    errors.push(
      "Wskazanie czy eksporter/wnioskodawca jest producentem jest wymagane."
    );
  if (
    [false, "false"].includes(data.transportDispatched) &&
    [false, "false"].includes(data.transportNotDispatched)
  )
    errors.push("Wskazanie czy transport został już wysłany jest wymagane.");
  if ([true, "true"].includes(data.transportDispatched)) {
    if (data.IE599File.id === "")
      errors.push("Dokument potwierdzający wywóz towaru jest wymagany.");
  }

  return errors;
}

function validateProductInProcess(product) {
  let errors = [];

  if (!validateProductName(product.name))
    errors.push(`Nazwa produktu ${product.name} jest nieprawidłowa.`);

  return errors;
}

function validateProcess(process) {
  let errors = [];

  process.Products.forEach((product) => {
    errors.push(...validateProductInProcess(product));
  });

  if (
    !validateLettersDigitsSpecChars(
      process.productionProcessDescription,
      1000,
      process.processFiles[0].name === ""
    )
  )
    errors.push(
      `Wymagane jest uzupełnienie opisu procesu produkcji lub załączenie dokumentu z jego opisem.`
    );
  return errors;
}

function validateStep3(data, step2data) {
  let errors = [];

  if ([false, "false"].includes(data.receiverUnknown)) {
    if (!validateLettersDigitsSpecChars(data.receiverName, 160, true))
      errors.push("Nazwa odbiorcy jest nieprawidłowa.");
    if (!validateLettersDigitsSpecChars(data.receiverAddress, 160, true, 4))
      errors.push("Dane adresowe odbiorcy są nieprawidłowe.");
    if (!validateCountryCode(data.receiverCountry, true))
      errors.push("Kraj odbiorcy jest nieprawidłowy.");
  } else if ([true, "true"].includes(data.receiverUnknown)) {
    if (
      !validateLettersDigitsSpecChars(
        data.unknownReceiverDescription,
        280,
        true,
        7
      )
    )
      errors.push(
        "Wskazana docelowa zawartość pola nr 2 na świadectwie jest nieprawidłowa."
      );
    if (!validateCountryCode(data.receiverCountry, true))
      errors.push("Kraj odbiorcy jest nieprawidłowy.");
  }

  let productToDescribe = [];
  step2data.Products.forEach((product) => {
    if ([true, "true"].includes(product.producer))
      productToDescribe.push(product.productName);
  });

  if (productToDescribe.length > 0) {
    data.Processes.forEach((process, index) => {
      errors.push(...validateProcess(process));

      if (!process.Products || process.Products.length === 0) {
        errors.push(
          `Brak produktów w opisie procesu produkcji nr ${index + 1}.`
        );
      }
    });

    let missingProducts = [];

    data.Processes.forEach((process) => {
      process.Products.forEach((product) => {
        const index = productToDescribe.indexOf(product.name);
        if (index > -1) {
          productToDescribe.splice(index, 1);
        } else {
          missingProducts.push(product.name);
        }
      });
    });

    if (productToDescribe.length > 0) {
      errors.push(
        `Brak opisu procesu produkcji dla produktów: ${productToDescribe.join(
          ", "
        )}.`
      );
    }

    if (missingProducts.length > 0) {
      errors.push(
        `W opisie procesu produkcji znajdują się produkty: ${missingProducts.join(
          ", "
        )}, które nie figurują w kroku 2 lub są wskazane w więcej niż jednym procesie. Usuń je z właściwego opisu procesu produkcji lub dodaj w kroku 2.`
      );
    }
  }

  return errors;
}

function validateStep4(data, step2data) {
  let errors = [];

  const exportFiles = asArray(data?.exportInvoiceFiles);
  if (exportFiles.length > 0) {
    if ((exportFiles[0]?.id ?? "") === "") {
      errors.push(
        "Faktura eksportowa lub faktura pro-forma dotycząca transakcji objętej świadectwem jest wymagana."
      );
    }
  } else {
    errors.push(
      "Faktura eksportowa lub faktura pro-forma dotycząca transakcji objętej świadectwem jest wymagana."
    );
  }

  if (["", null, undefined].includes(data?.exportInvoiceValue))
    errors.push("Wskazanie wartości eksportu jest wymagane.");
  if (["", null, undefined].includes(data?.exportInvoiceCurrency))
    errors.push("Wskazanie waluty jest wymagane.");

  const connections = normalizeConnections(data?.goodsFilesConnections);
  const products = asArray(step2data?.Products);

  let productToAttachFilesTo = [];
  products.forEach((product) => {
    if ([true, "true"].includes(product?.exporter)) {
      let found = false;

      connections.forEach((connection) => {
        connection.forEach((connectedProduct) => {
          if (connectedProduct?.productName === product?.productName) {
            found = true;
          }
        });
      });

      if (!found) productToAttachFilesTo.push(product?.productName);
    }
  });

  if (productToAttachFilesTo.length > 0)
    errors.push(
      `Brak załączonych faktur zakupu do towarów: ${productToAttachFilesTo.join(
        ", "
      )}.`
    );

  return errors;
}

function validateStep5(data, step1data, step2data) {
  let errors = [];
  let statementsToCheck = 7;
  if (step1data.exporterIsNotProducer === "true") statementsToCheck = 6;
  else if (step1data.exporterIsProducer === "true") {
    let producerOnly = true;
    if (step2data.Products) {
      step2data.Products.forEach((product) => {
        if (product.exporter === "true") {
          producerOnly = false;
        }
      });
    }
    if (producerOnly) statementsToCheck = 6;
  }
  let allStatementsChecked = true;
  for (let i = 0; i < statementsToCheck; i++) {
    if (data.statements[i] === false) {
      allStatementsChecked = false;
    }
  }
  if (!allStatementsChecked)
    errors.push("Zaznaczenie wszystkich oświadczeń jest wymagane.");

  if (!["true", true, "false", false].includes(data.printYes))
    errors.push("Określenie czy potrzebujesz wydruk świadectwa jest wymagane.");
  if (["true", true].includes(data.printYes))
    if (!["courier", "pickup"].includes(data.shippingMethod))
      errors.push("Określenie formy dostawy świadectwa jest wymagane.");
    else if (data.shippingMethod === "courier") {
      if (!validateBusinessName(data.ShippingAddress.name))
        errors.push("Nazwa odbiorcy jest nieprawidłowa.");
      if (!validateStreet(data.ShippingAddress.street))
        errors.push("Adres odbiorcy jest nieprawidłowy.");
      if (!validateBuilding(data.ShippingAddress.building))
        errors.push("Numer domu odbiorcy jest nieprawidłowy.");
      if (!validateAppartment(data.ShippingAddress.appartment))
        errors.push("Numer lokalu odbiorcy jest nieprawidłowy.");
      if (!validatePostCode(data.ShippingAddress.postCode))
        errors.push("Kod pocztowy odbiorcy jest nieprawidłowy.");
      if (!validateCity(data.ShippingAddress.city))
        errors.push("Miasto odbiorcy jest nieprawidłowe.");
      if (data.ShippingAddress.phoneNumber === "")
        errors.push("Numer telefonu dla kuriera jest wymagany.");
    }

  return errors;
}

export {
  validateNIP,
  validateBusinessName,
  validateStreet,
  validateBuilding,
  validateAppartment,
  validateCity,
  validateCountryCode,
  validatePostCode,
  validateProductName,
  validateLettersDigits,
  validateLettersDigitsSpecChars,
  validateDigits,
  validateDecimalNumber,
  validateLetters,
  validateEmail,
  validateStep1,
  validateStep2,
  validateStep3,
  validateStep4,
  validateStep5,
  validateTariffCode,
};


